import React from 'react';

const TermsOfUse = () => {
  return (
    <div style={styles.body}>
      <div style={styles.container}>
        <h1>Terms of Use</h1>
        <p><strong>Effective Date: &nbsp;23-Dec-2025</strong></p>

     

        <p>
          By accessing or using this Website, you agree to be bound by these Terms.
          If you do not agree, please discontinue use of the Website.
        </p>

        <h2>1. Website Use</h2>
        <p>
          This Website is intended to provide information regarding our construction
          and development services and projects. You agree to use the Website only
          for lawful purposes and in compliance with applicable laws and regulations.
        </p>

        <h2>2. Eligibility</h2>
        <p>
          By using this Website, you confirm that you are at least 18 years of age,
          or that you are accessing the Website under the supervision of a parent
          or legal guardian.
        </p>

        <h2>3. Intellectual Property Rights</h2>
        <p>
          All content on this Website, including text, images, graphics, logos,
          layouts, designs, videos, and software, is the property of
          MITHA CONSTRUCTION AND DEVELOPMENT or its licensors and is protected by
          applicable intellectual property laws.
        </p>
        <p>You may not:</p>
        <ul style={styles.list}>
          <li>Copy, reproduce, modify, or distribute Website content</li>
          <li>Use Website materials for commercial purposes without written consent</li>
        </ul>

        <h2>4. User Submissions</h2>
        <p>
          When submitting information through contact forms or inquiries, you agree
          that the information provided is accurate and lawful. You shall not submit
          any content that is illegal, misleading, defamatory, or harmful.
        </p>

        <h2>5. Project Information Disclaimer</h2>
        <p>
          All project details, plans, images, specifications, pricing, and timelines
          displayed on this Website are indicative only and subject to change without
          prior notice. Nothing on this Website constitutes a legal offer or contractual
          obligation.
        </p>

        <h2>6. Third-Party Links</h2>
        <p>
          This Website may contain links to third-party websites for convenience.
          We do not control or endorse such websites and are not responsible for
          their content or privacy practices.
        </p>

        <h2>7. Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by law, MITHA CONSTRUCTION AND DEVELOPMENT
          shall not be liable for any direct, indirect, incidental, or consequential
          damages arising from your use of or inability to use this Website.
        </p>

        <h2>8. Indemnification</h2>
        <p>
          You agree to indemnify and hold harmless MITHA CONSTRUCTION AND DEVELOPMENT,
          its directors, employees, and affiliates from any claims or liabilities
          arising from your use of the Website or violation of these Terms.
        </p>

        <h2>9. Privacy Policy</h2>
        <p>
          Your use of this Website is also governed by our Privacy Policy.
          By using the Website, you consent to the collection and use of information
          as described therein.
        </p>

        <h2>10. Modifications to Terms</h2>
        <p>
          We reserve the right to update or modify these Terms at any time without
          prior notice. Continued use of the Website constitutes acceptance of the
          revised Terms.
        </p>

        <h2>11. Governing Law and Jurisdiction</h2>
        <p>
          These Terms shall be governed by and construed in accordance with the laws
          of India. Any disputes shall be subject to the exclusive jurisdiction of
          the courts in India.
        </p>

        <h2>12. Contact Information</h2>
        <p>
          For questions regarding these Terms of Use, please contact:
        </p>
        <p>
          <strong>MITHA CONSTRUCTION AND DEVELOPMENT</strong><br/>
          Website: www.mithahomes.com<br/>
          Email: [Insert Official Email Address]<br/>
          Phone: [Insert Contact Number]
        </p>

        <p style={styles.footerNote}>
          © 2025 MITHA CONSTRUCTION AND DEVELOPMENT. All rights reserved.
        </p>
      </div>
    </div>
  );
};

const styles = {
  body: {
    fontFamily: "'Roboto', sans-serif",

    color: '#1a331a',
    margin: 0,
    padding: 0,
    lineHeight: 1.7,
    minHeight: '100vh',
  },
  container: {
    maxWidth: '1000px',
    margin: '30px auto',
    background: '#ffffff',
    padding: '30px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    borderTop: '5px solid #2e7d32',
  },
  list: {
    marginLeft: '20px',
    paddingLeft: '0',
  },
  footerNote: {
    marginTop: '30px',
    fontSize: '14px',
    color: '#4a6c4a',
    borderTop: '1px solid #c8e6c9',
    paddingTop: '15px',
  },
};

// For the headings, we'll add CSS via a style tag
const HeadingsStyle = () => (
  <style>{`
    h1, h2 {
      color: #1b5e20;
    }
    h1 {
      font-size: 28px;
      margin-bottom: 10px;
      border-bottom: 2px solid #81c784;
      padding-bottom: 10px;
    }
    h2 {
      font-size: 20px;
      margin-top: 25px;
      color: #2e7d32;
    }
    strong {
      color: #1b5e20;
    }
    li {
      margin-bottom: 8px;
      color: #2e3f2e;
    }
    p {
      margin: 10px 0;
    }
  `}</style>
);

const TermsOfUseWithStyles = () => (
  <>
    <HeadingsStyle />
    <TermsOfUse />
  </>
);

export default TermsOfUseWithStyles;